"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendOnboardingGenreEvent = exports.sendEmailVerificationTrackingEvent = exports.sendOnBoardingCompleteTrackingEvent = exports.sendOnBoardingStartTrackingEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a track onboarding start
 * Event name: "web:onboarding:::start"
 */
var sendOnBoardingStartTrackingEvent = function () {
    (0, _1.sendEvent)("onboarding", null, null, "start", {});
};
exports.sendOnBoardingStartTrackingEvent = sendOnBoardingStartTrackingEvent;
/**
 * Sends an event that a track onboarding complete
 * Event name: "web:onboarding:::complete"
 */
var sendOnBoardingCompleteTrackingEvent = function () {
    (0, _1.sendEvent)("onboarding", null, null, "complete", {});
};
exports.sendOnBoardingCompleteTrackingEvent = sendOnBoardingCompleteTrackingEvent;
/**
 * Sends an event that a track email verification on onboarding
 * Event name: "web::::onboarding_user_lifecycle_v0"
 */
var sendEmailVerificationTrackingEvent = function () {
    (0, _1.sendEvent)(null, null, null, "onboarding_user_lifecycle_v0", {
        email_verify: {},
    });
};
exports.sendEmailVerificationTrackingEvent = sendEmailVerificationTrackingEvent;
/**
 * Sends an event that a track genre selection on onboarding
 * Event name: "web::::onboarding_user_lifecycle_v0"
 */
var sendOnboardingGenreEvent = function (genres) {
    (0, _1.sendEvent)(null, null, null, "onboarding_user_lifecycle_v0", {
        genre_select: {
            genres: genres,
        },
    });
};
exports.sendOnboardingGenreEvent = sendOnboardingGenreEvent;
